import React, { Component } from 'react';
//import { Container, Navbar, NavbarText } from 'reactstrap';
//import { Input } from 'reactstrap';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import configData from '../config.json';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import ImeiListe from '../components/ImeiListe';
import { CardBody, CardFooter, CardHeader } from 'react-bootstrap';

export default class Imei extends Component {

    state = {
        isLoggedIn: true,
        exTools: null,
        input: '',
        ean: '',
        imei: {
            ean: '',
            art: '',
            name: '',
            imei: null,
            imei2: null,
        },
        artikelList: [],
        artikelListeErfasst: [],
        imeiList: {},
        helpShow: false,
        token: null

    }

    constructor(props) {
        super(props);

        this.onChangeInput = this.onChangeInput.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

      _fetchArtikel = async (ean) => {
           
            var body = '';
            body += `params[ean]=` + ean;
            body +=  "&token=" + this.state.token;

           //console.log(body);        
         //console.log('_fetchArtikel', body);
      
              const response = await fetch(configData.SERVER_URL + '/artikelean', {
                  headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                  },            
                  method: 'POST',
                  body: body,
              });
              // eslint-disable-next-line no-unused-vars
              //console.log(response.text());
              const responseJson = await response.json();
 
           //console.log("return", responseJson.status.data, responseJson);
  
              if(responseJson.status !== false && responseJson.data.length > 1) {
  
                  //Artikel  bezeichnung und menge zu this.state.artikel hinzufügen
                this.setState({
                    input: '',
                        artikelList: responseJson.data
                    });
                  //console.log("return", responseJson);
                  //return responseJson.data;
                  //this.props.toggle();
                  //window.location.reload(false);
      
              } else if(responseJson.status !== false && responseJson.data.length > 0) {
  
                //Artikel  bezeichnung und menge zu this.state.artikel hinzufügen
                this.setState({
                    input: '',
                        imei: {
                            ean: ean, 
                            art: responseJson.data[0].ArtNr, 
                            name: responseJson.data[0].Bezeichnung,
                            imei: null,
                            imei2: null
                        }});
                //console.log("return", responseJson);
                //return responseJson.data;
                //this.props.toggle();
                //window.location.reload(false);
    
            } else if(responseJson.status !== false && this.state.input.length === 13) {
                //console.log("return", responseJson);
                this.setState({
                    input: '',
                    imei: {
                        ean: ean, 
                        art: '00000000000', 
                        name: 'Artikel unbekannt',
                        imei: null,
                        imei2: null
                    }});
            }
      }
  

    submitArt = async () => {
        var input = '';
        if(this.state.input.length === 13) {
            input = this.state.input;
        } else if(this.state.input.length === 12) {
            input = '0' + this.state.input;
        }
        const artikelListeErfasst = this.state.artikelListeErfasst;
       //console.log('artikelListeErfasst', this.state.artikelListeErfasst);
        var body = null;
        if(this.state.token) {
            //console.log('Aussteller Token');
            body =  "token=" + this.state.token;
        } else if(this.pcode) {
          body = "code=" + this.pcode;
          this.pcode = null;
        }
        body += "&params[filiale]=" + sessionStorage.getItem('filiale');

        if(this.state.imei.ean !== '' && this.state.imei.ean.length === 12) {
            body += "&params[ean]=0" + this.state.imei.ean;
        } else {
            body += "&params[ean]=" + this.state.imei.ean;
        }
        if(this.state.imei.art !== '') {
            body += "&params[art]=" + this.state.imei.art;
        }
        if(this.state.imei.imei !== null) {
            body += "&&params[imei]=" + this.state.imei.imei;
        }
        if(this.state.imei.imei2 !== null) {
            body += "&&params[imei2]=" + this.state.imei.imei2;
        }
        if(body !== null) {
         //console.log('submitArt', body);
          const response = await fetch(configData.SERVER_URL + 'imei', {
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
              },            
              method: 'POST',
              body: body,
          });
          const responseJson = await response.json();
          //console.log('responseJson', responseJson);
            //this.token = responseJson.user.Ergebnis;
          if(responseJson.status === true) {
            artikelListeErfasst.push(this.state.imei);
            //sessionStorage.setItem('exTools', JSON.stringify(responseJson.user));
            this.setState({
                input: input,
                imei: {
                    ean: '',
                    art: '',
                    name: '',
                    imei: null,
                    imei2: null,
                },
                artikelListeErfasst: artikelListeErfasst,
                artikelList: []
            });
          } else {
            //sessionStorage.clear();
            //window.open("/");
          }
        }
    }

    componentDidMount() {
        if(sessionStorage.getItem('exTools')) {
            const response = sessionStorage.getItem('exTools');
            const responseJson = JSON.parse(response);
            //console.log('DidMount Aussteller', responseJson.Ergebnis);
            if(responseJson.Ergebnis !== 'undefined') {
                this.setState({
                    token: responseJson.Ergebnis,
                    exTools: responseJson,
                });
            }
        }
    }

    componentDidUpdate() {
       //console.log('componentDidUpdate', this.state.input, this.state.imei);
       //console.log('artikelListeErfasst', this.state.artikelListeErfasst);

        if(this.state.imei.imei2 !== null) {
            //console.log('componentDidUpdate', this.state.input);
            this.submitArt();
        }
    }

    onChangeInput(e) {
       //console.log('onChangeInput', e.key);
        this.setState({input: e.target.value});
    }

    handleKeyDown(e) {
      //console.log('handleKeyDown', e.key,  e.target.value, e.target.value.length , this.state.imei);
       if(e.key === 'Enter') {
                if(e.target.value.length === 15 && !this.state.imei.imei) {
           //console.log('Imei', e.target.value);
            this.setState({
                input: '',
                imei: {
                    ...this.state.imei, 
                    imei: e.target.value
                }
            });        
        } else if(e.target.value.length === 15 && !this.state.imei.imei2) {
           //console.log('Imei2', e.target.value);
            this.setState({
                input: '',
                imei: {
                    ...this.state.imei, 
                    imei2: e.target.value
                }
            });
        } else if(e.target.value.length >= 12) {
            console.log('handleKeyDown', e.target.value);
              if(this.state.imei.imei !== null) {
                  this.submitArt();
              } else {
                if(this.state.input.length === 12) {
                    this._fetchArtikel('0' + this.state.input);
                } else if(this.state.input.length === 13) {
                    this._fetchArtikel(this.state.input);
                }
              }
          }
       }

        e.preventDefault();

    }


    render() {
        if(this.state.exTools) {
           //console.log('Imei Render', this.state);
          //console.log('artikelListeErfasst', this.state.artikelListeErfasst );

            return (
                    <>
                    <Container style={{padding: "4rem 0px 0px 0px"}} className='mb-3'>
                    <Card bg="primary">
                        <CardHeader className="text-center fs-4 text-white">{this.state.imei.name === '' ? '???' : this.state.imei.name}</CardHeader>
                        <CardBody>
                        <Row className='mx-1'>
                            <Col className="col-2 fs-5 text-end">
                            Artikel Nr.
                            </Col>
                            <Col className="col-4 fs-5 text-white">
                            {this.state.imei.art.slice(0, 3) + " " + this.state.imei.art.slice(3, 8) + " " + this.state.imei.art.slice(8)}
                            </Col>
                            <Col className="col-2 fs-5 text-end">
                            EAN<br />
                            </Col>
                            <Col className="col-4 fs-5 text-white">
                            {this.state.imei.ean}
                            </Col>

                        </Row>
                        <Row className='mx-1'>
                            <Col className="col-2 fs-5 text-end">
                            IMEI
                            </Col>
                            <Col className="col-4 fs-5 text-white">
                            {this.state.imei.imei}
                            </Col>
                            <Col className="col-2 fs-5 text-end">
                            IMEI2
                            </Col>
                            <Col className="col-4 fs-5 text-white">
                            {this.state.imei.imei2}
                            </Col>
                        </Row>
                        </CardBody>
                        <Modal
                            show={this.state.artikelList.length > 1 ? true : false}
                            backdrop="static"
                            keyboard={false}
                        >

                            <Modal.Header closeButton className='bg-danger-subtle'>
                                <Modal.Title>Artikel Auswahl</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                {

                                    this.state.artikelList.map((element, i) => {
                                        return (
                                            <Row key={i} className="bg-warning-subtle mb-3 border border-botton" onClick={() => 
                                                    this.setState({
                                                        input: '', 
                                                        artikelList: [], 
                                                        imei: {...this.state.imei, 
                                                            art: element.ArtNr, 
                                                            ean: element.EAN, 
                                                            name: element.Bezeichnung,
                                                            imei: null,
                                                            imei2: null
                                                            }
                                                        }
                                                    )}>
                                            
                                                <Col xs={3} className='m-3 fs-5'>{element.ArtNr.slice(0, 3) + " " + element.ArtNr.slice(3, 8) + " " + element.ArtNr.slice(8)}</Col>
                                                <Col className='m-3 fs-5'>{element.Bezeichnung}</Col>
                                            </Row>
                                        )
                                    })

                                }

                            </Modal.Body>

                        </Modal>
                        <CardFooter>
                        <Row className='m-3'>
                            <Col xs={2}></Col>

                            <Col>
                                <Form.Control
                                size="lg"
                                className="mb-3"
                                placeholder="Scan"
                                name="input"
                                value={this.state.input}
                                onChange={(e) => 
                                    this.setState({input: e.target.value})
                                } 
                                onKeyUp={this.handleKeyDown}
                                />
                            </Col>
                            <Col xs={2}>
                            {
                                this.state.imei.imei !== null
                                ? <Button variant="success" onClick={() => this.submitArt()}>speichern</Button>
                                : null
                            }
                            </Col>
                        </Row>
                        </CardFooter>
                        </Card>

                        {/* {

                            this.state.artikelListeErfasst !== null && this.state.artikelListeErfasst.length > 0
                            ? this.state.artikelListeErfasst.map((element, i) => {
                                return (
                                    <Row key={i} className="mb-1 border border-botton">
                                        <Col xs={3} className='m-1'>{element.art.slice(0, 3) + " " + element.art.slice(3, 8) + " " + element.art.slice(8)}</Col>
                                        <Col className='m-1'>{element.imei}</Col>
                                        <Col className='m-1'>{element.imei2}</Col>
                                    </Row>
                                )
                            })
                            : <></>

                        } */}

                    </Container>

                    {
                        
                        this.state.artikelListeErfasst !== null && this.state.artikelListeErfasst.length > 0 
                        ? <ImeiListe artikelListeErfasst={this.state.artikelListeErfasst} />
                        : null

                    }

                    

                    <Container style={{padding: "0px 20px 0px 20px"}} className="text-end fixed-bottom">
                        <Button variant="outline-info" onClick={() => this.setState({helpShow: !this.state.helpShow})}>
                            <i className="bi bi-info-circle-fill fs-4"></i>
                        </Button>
                        
                        <Modal show={this.state.helpShow} onHide={() => this.setState({helpShow: !this.state.helpShow})}>
                            <Modal.Header closeButton>
                                <Modal.Title>IMEI Scan Anleitung</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <Row className='m-3'>
                                <Col xs={2}></Col>
                                <Col>
                                    <ul className="list-unstyled">
                                        <li>1. EAN scannen</li>
                                        <ul>
                                            <li>EAN ist eindeutig, Artikel wird gesetzt</li>
                                            <li>EAN ist nicht eindeutig, Artikel Auswahl</li>
                                            <li>EAN ist unbekannt, Artikel wird als unbekannt erfasst</li>
                                        </ul>
                                        <li>2. IMEI scannen</li>
                                        <li>3. IMEI2 scannen oder <Button variant="success" disabled>speichern</Button> drücken</li>
                                        <li><b>In beiden fällen wird gespeichert!</b></li>
                                    </ul>
                                </Col>
                                <Col xs={2}></Col>
                            </Row>

                            </Modal.Body>
                        </Modal>
                    </Container>

                    </>
            );            
        } else {
            return (
                <>test</>
            )
        }
    }
}